import { CollapsibleCard, InfoModal, VStack } from "@starrez/starryui";
import * as React from "react";
import { AttachmentErrorType, IAttachmentError } from "..";
import { strings } from "../../../../../localisation";
import { AttachmentErrorListItem, AttachmentErrorUnorderedList } from "./AttachmentErrors.styles";

export interface IAttachmentErrorsProps {
    Errors: IAttachmentError[];
    OnClose: () => void;
}

const getCaptionTextForSizeErrors = (size: IAttachmentError[]) => {
    return size.length > 1 ? strings.Message_Upload_ErrorSize_MultipleFiles : strings.Message_Upload_ErrorSize_SingleFile;
};

export const AttachmentErrors = ({ Errors, OnClose }: IAttachmentErrorsProps) => {

    const duplicates = Errors.filter((err) => err.ErrorType === AttachmentErrorType.Duplicate);
    const size = Errors.filter((err) => err.ErrorType === AttachmentErrorType.Size);

    if (duplicates.length || size.length) {
        return (
            <InfoModal Header={strings.Message_Upload_ErrorHeader} InfoType="Error" OnCloseRequest={OnClose}>
                <VStack Gap="none">
                    {duplicates.length > 0 &&
                        <CollapsibleCard Caption={strings.Message_Upload_ErrorDuplicate}>
                            <AttachmentErrorUnorderedList>
                                {duplicates.map((file) => {
                                    return <AttachmentErrorListItem key={file.Attachment.File.name}>{file.Attachment.File.name}</AttachmentErrorListItem>;
                                })}
                            </AttachmentErrorUnorderedList>
                        </CollapsibleCard>
                    }
                    {size.length > 0 &&
                        <CollapsibleCard Caption={getCaptionTextForSizeErrors(size)}>
                            <AttachmentErrorUnorderedList>
                                {size.map((file) => {
                                    return <AttachmentErrorListItem key={file.Attachment.File.name}>{file.Attachment.File.name}</AttachmentErrorListItem>;
                                })}
                            </AttachmentErrorUnorderedList>
                        </CollapsibleCard>
                    }
                </VStack>
            </InfoModal>
        );
    }

    return null;
};
